import { Clipboard, TerminalSquare, Cloud, Folder, Settings } from 'lucide-react';
import { useStore } from '../../store/useStore';
import type { AppType } from '../../types';

export const APP_DEFINITIONS: Record<string, { appType: AppType; icon: typeof Folder; color: string; description: string }> = {
  terminal: { appType: 'terminal', icon: TerminalSquare, color: '#7dcfff', description: 'Linux terminal' },
  files: { appType: 'file-manager', icon: Folder, color: '#e0af68', description: 'Google Drive files' },
  projects: { appType: 'projects', icon: Clipboard, color: '#bb9af7', description: 'Your projects' },
  editor: { appType: 'editor', icon: Clipboard, color: '#9ece6a', description: 'Code editor' },
  chat: { appType: 'chat', icon: Cloud, color: '#7aa2f7', description: 'AI assistant' },
  settings: { appType: 'settings', icon: Settings, color: '#c0caf5', description: 'Preferences' },
};

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export function Loader({ size = 'md', text }: LoaderProps) {
  const dims = { sm: 'w-6 h-6', md: 'w-10 h-10', lg: 'w-14 h-14' };
  return (
    <div className="flex flex-col items-center gap-4">
      <div className={`${dims[size]} border-4 border-desktop-border border-t-desktop-accent rounded-full animate-spin`} />
      {text && <p className="text-sm text-desktop-text/70">{text}</p>}
    </div>
  );
}

export const APP_TYPES: AppType[] = ['terminal', 'editor', 'file-manager', 'browser', 'chat', 'settings', 'projects', 'preview'];

export { useStore };